import SimilarMovies from './SimilarMovies';

export default SimilarMovies;
